import { ColorMode } from '../theme/modes.config';
import { createContext } from '../utils/create-context';

export interface ColorModeProviderProps {
  colorMode: ColorMode;
  setColorMode: (colorMode: ColorMode) => void;
}

export const [ColorModeProvider, useColorModeContext, ColorModeContext] =
  createContext<ColorModeProviderProps>({
    requiresProvider: true,
    name: 'ColorModeProvider',
  });
